import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Divider = styled.div(({ theme, textColor }) => {
  const text = theme?.colors?.[textColor]?.base?.hex || 'white'

  return css`
    width: 1px;
    height: 42px; // Hard setting a pixel amount to at least match the height of the button. Setting to 100% doesn't work since the container height is dynamic.
    background-color: ${text};
  `
})

export const Container = styled.div(
  ({ theme, backgroundColor, textColor, isVisible }) => {
    const background = theme?.colors?.[backgroundColor]?.base?.hex || 'primary'
    const text =
      theme?.colors?.[textColor]?.base?.hex || theme?.colors?.dark?.base?.hex

    // Base styles applied to both sticky and non-sticky versions
    const baseStyles = css`
      position: relative;
      z-index: 1;
      display: flex;
      gap: 24px;
      padding: 16px;
      justify-content: center;
      align-items: center;
      background-color: ${background};
      color: ${text};
      font-size: 18px;

      .leshen-typography-body,
      .leshen-typography-h1,
      .leshen-typography-h2,
      .leshen-typography-h3,
      .leshen-typography-h4,
      .leshen-typography-h5,
      .leshen-typography-h6 {
        // Turning off margins because the CTA Bar has it's own spacing. This specifically solves the "buttons as modal triggers" having margins.
        margin-top: 0;
        margin-bottom: 0;
      }

      @media (max-width: ${theme.breakpoints.sm}) {
        > .leshen-typography-body {
          display: none;

          + ${Divider} {
            display: none;
          }

          &:has(.leshen-modal-trigger) {
            display: block;
          }
        }

        .leshen-form {
          .group {
            display: flex;

            button:last-of-type {
              margin-top: 0;
              border-top-left-radius: 0;
              border-top-right-radius: 4px;
              border-bottom-left-radius: 0;
              width: fit-content;
            }

            * {
              font-size: 16px;
            }
          }
        }
      }
    `

    // Additional sticky styles
    const stickyStyles =
      isVisible !== undefined
        ? css`
            transform: translateY(${isVisible ? '0' : '100%'});
            z-index: 3;
            position: fixed;
            opacity: ${isVisible ? 1 : 0};
            bottom: 0;
            width: 100%;
            transition: transform 0.5s cubic-bezier(1, 0.05, 0.17, 1.09),
              opacity 0.5s cubic-bezier(1, 0.05, 0.17, 1.09);
          `
        : ''

    return css`
      ${baseStyles};
      ${stickyStyles};
    `
  }
)
